<div
  class="modal-content pending-modal"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="false"
>
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ "RIDP_PENDING_HEADER" | globalTranslate }}
    </h1>
  </div>
  <div class="modal-body text-center">
    <nh-alert type="warning" [isOpen]="displayTimestampBanner">
      <div class="row">
        <div class="col-auto icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33.5"
            height="33.5"
            viewBox="0 0 33.5 33.5"
          >
            <path
              id="Path_737"
              data-name="Path 737"
              d="M80,64A16,16,0,1,0,96,80,16,16,0,0,0,80,64Z"
              transform="translate(-63.25 -63.25)"
              fill="#f4cc43"
              stroke="#f4cc43"
              stroke-miterlimit="10"
              stroke-width="1.5"
            />
            <path
              id="Path_738"
              data-name="Path 738"
              d="M256,128v12h8"
              transform="translate(-239.25 -121.917)"
              fill="#f4cc43"
              stroke="#fff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
            />
          </svg>
        </div>
        <div class="col message">
          <span
            [innerHTML]="'RIDP_CANT_VERIFY_ALERT_INVESTIGATE' | globalTranslate"
          ></span
          ><span>{{ minutes }}</span
          ><span [innerHTML]="'RIDP_MINUTES' | globalTranslate"></span>
        </div>
      </div>
    </nh-alert>
    <nh-alert type="warning" [isOpen]="displayServiceDownError">
      <div class="row">
        <div class="col-auto icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33.5"
            height="33.5"
            viewBox="0 0 33.5 33.5"
          >
            <path
              id="Path_737"
              data-name="Path 737"
              d="M80,64A16,16,0,1,0,96,80,16,16,0,0,0,80,64Z"
              transform="translate(-63.25 -63.25)"
              fill="#f4cc43"
              stroke="#f4cc43"
              stroke-miterlimit="10"
              stroke-width="1.5"
            />
            <path
              id="Path_738"
              data-name="Path 738"
              d="M256,128v12h8"
              transform="translate(-239.25 -121.917)"
              fill="#f4cc43"
              stroke="#fff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
            />
          </svg>
        </div>
        <div class="col message">
          <span [innerHTML]="'RIDP_SERVICEDOWN_TEXT' | globalTranslate"></span>
        </div>
      </div>
    </nh-alert>
    <nh-alert
      type="warning"
      [isOpen]="displayInvestigateErrorBanner"
      class="investigate-banner"
    >
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span class="visually-hidden">{{ "Alert" | globalTranslate }}</span>
          <span
            [innerHtml]="'RIDP_CANT_VERIFY_ALERT_INV_01' | globalTranslate"
          ></span>
        </div>
      </div>
    </nh-alert>
    <img
      class="pending-icon"
      aria-hidden="true"
      src="../../../assets/images/Icons/identity-pending.svg"
      [alt]=""
    />
    <div class="content-section">
      <p class="hub-reference">
        <span class="hub-reference-header">{{
          "RIDP_PENDING_HUB_REF" | globalTranslate
        }}</span
        ><br /><span class="hub-number">{{ hubReferenceNumber }}</span>
      </p>
      <p class="step-row">
        <strong class="step-label" style="color: #174a7c">{{
          "RIDP_STEP_1" | globalTranslate
        }}</strong
        >&nbsp;&nbsp;&nbsp;&nbsp;
        <span
          class="step-instruction"
          [innerHTML]="'RIDP_PENDING_TEXT' | globalTranslate"
        ></span>
        <span
          ><b
            class="step-instruction"
            [innerHTML]="'RIDP_PENDING_TEXT_01' | globalTranslate"
          ></b
        ></span>
        <span
          class="step-instruction"
          [innerHTML]="'RIDP_PENDING_TEXT_02' | globalTranslate"
        ></span>
      </p>
      <div class="contact-section">
        <a aria-hidden="true" href="tel:833-203-6550" class="phone-link">
          <img
            alt=""
            class="phone-icon"
            src="../../../assets/images/Icons/icons-call-outline-1.svg"
          />
          <span class="phone-number">833-203-6550</span>
        </a>
        <div class="hours-section">
          <p class="hours-text">
            {{ "RIDP_PENDING_HOURS_HEADER" | globalTranslate }}
          </p>
          <p class="hours-text">{{ "RIDP_PENDING_HOURS_1" | translate }}</p>
          <p class="hours-text">{{ "RIDP_PENDING_HOURS_2" | translate }}</p>
          <p class="hours-text">{{ "RIDP_PENDING_HOURS_3" | translate }}</p>
        </div>
      </div>
      <hr />
      <p class="hub-reference">
        {{ "RIDP_HAVEYOU_CONTACTED" | globalTranslate }}
      </p>
      @if (!invIdentityVerify) {
      <p class="step-row">
        <strong class="step-label" style="color: #174a7c">{{
          "RIDP_STEP_2" | globalTranslate
        }}</strong
        >&nbsp;&nbsp;&nbsp;&nbsp;
        <span
          class="step-instruction"
          [innerHTML]="'RIDP_HAVEYOU_CONTACTED_DATA' | globalTranslate"
        ></span>
        <span
          ><b
            class="step-instruction"
            [innerHTML]="'RIDP_HAVEYOU_CONTACTED_DATA_01' | globalTranslate"
          ></b
        ></span>
        <span
          class="step-instruction"
          [innerHTML]="'RIDP_HAVEYOU_CONTACTED_DATA_02' | globalTranslate"
        ></span>
      </p>
      } @if (invIdentityVerify) {
      <p style="line-height: 1.5">
        <strong class="step-label" style="color: #174a7c">{{
          "RIDP_STEP_2" | globalTranslate
        }}</strong
        >&nbsp;&nbsp;&nbsp;&nbsp;
        <span [innerHTML]="'RIDP_INVESTIGAT_TEXT_01' | globalTranslate"></span
        ><br />
        <span
          class="inv_text"
          [innerHTML]="'RIDP_INVESTIGAT_TEXT_02' | globalTranslate"
        ></span
        ><br />
        <span
          class="inv_text mt-3"
          [innerHTML]="'RIDP_INVESTIGAT_TEXT_03' | globalTranslate"
        ></span>
      </p>
      } @if (invIdentityVerify) {
      <div class="checkbox-container mt-4 mb-3">
        <div class="d-flex align-items-center mb-1">
          <span class="text-danger fw-bold me-2" aria-hidden="true">*</span>
          <nh-checkbox
            name="calledYes"
            [index]="''"
            [control]="calledExperianForm?.controls['calledYes']"
            checkedValue="checked"
            [mandatory]="false"
            (change)="onCheckboxChange('calledYes')"
          ></nh-checkbox>
          <label
            for="checkbox-calledYes"
            style="cursor: pointer"
            [innerHTML]="'RIDP_CHECKBOX_YES_LABEL' | globalTranslate"
          >
          </label>
        </div>
        <div class="d-flex align-items-center mb-3">
          <span class="me-2" style="visibility: hidden" aria-hidden="true"
            >*</span
          >
          <nh-checkbox
            name="calledNo"
            [index]="''"
            [control]="calledExperianForm?.controls['calledNo']"
            checkedValue="checked"
            [mandatory]="false"
            (change)="onCheckboxChange('calledNo')"
          ></nh-checkbox>
          <label
            for="checkbox-calledNo"
            style="cursor: pointer"
            [innerHTML]="'RIDP_CHECKBOX_NO_LABEL' | globalTranslate"
          >
          </label>
        </div>
        <div class="text-center">
          <button
            type="button"
            id="continue-proofing-btn"
            class="btn btn-secondary continue-btn"
            [disabled]="isConfirmDisabled()"
            (click)="onConfirmSelection()"
          >
            {{ "RIDP_CONFIRM_BTN" | globalTranslate }}
          </button>
        </div>
      </div>
      }
    </div>
  </div>
  <div class="modal-footer flex-column">
    @if (!invIdentityVerify) {
    <button
      type="button"
      id="continue-proofing-btn"
      class="btn btn-primary continue-btn"
      [disabled]="displayTimestampBanner"
      (click)="onContinueWithIdProofing()"
    >
      {{ "RIDP_PENDING_BTN_CONTINUE" | globalTranslate }}
    </button>
    } @if (!isMobileUser) {
    <div class="alternative-actions">
      <p class="apply-text">
        <br />
        {{ "RIDP_PENDING_APPLY_TEXT_PENDING" | globalTranslate }}
        <br /><a tabindex="0" class="action-link" (click)="onGoToDashboard()"
          ><span class="nav_links">{{
            "RIDP_DASHBOARD_LINK" | globalTranslate
          }}</span></a
        >
      </p>
    </div>
    } @if (isMobileUser) {
    <div class="modal-body text-center">
      <p class="instruction-text">
        {{ "MOBILE_IDVERIFY_TEXT_02" | globalTranslate }}
      </p>
    </div>
    }
  </div>
</div>